/* src/app/feature-modules/student-list/create-edit-student/create-edit-student.component.css */
li {
  margin-top: 6px;
}
.list-files {
  display: flex;
  vertical-align: middle;
  padding: 2px 12px;
  border-radius: 4px;
  border: solid 1px #00b0e0;
  background-color: #bdf1ff70;
  align-items: center;
  white-space: nowrap;
}
.list-files a {
  margin-right: 12px;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-files > span {
  flex: 0 0 auto;
}
.list-files .mat-icon {
  width: auto;
  height: auto;
  position: relative;
  top: 3px;
}
/*# sourceMappingURL=create-edit-student.component.css.map */
